enum WidgetYaPayThemes {
  BUTTON = 'Compact',
  SPLIT = 'BnplOffer',
}

export default WidgetYaPayThemes
